import * as React from "react";
import { observer } from "mobx-react";
import { injectIntl, InjectedIntlProps } from "react-intl";
import {RouteComponentProps, withRouter} from "react-router";
import "./UserInf.less";
import { teamStore } from "../../../models/TeamStore";
import { Form, message, Input, Button } from "antd";
import { loginStore } from "../../../models/LoginStore";
import { miniPersistStore } from "../../../models/MiniPersistStore";
import {FormInstance} from "antd/lib/form";
import {consoleApi} from "../../../apiMiddleware";
const FormItem = Form.Item;

export type UserCenterProps = InjectedIntlProps & RouteComponentProps<{ tab: string }>;

@observer
class UserInf extends React.Component<UserCenterProps, {}> {
    private readonly formRef: React.RefObject<FormInstance> = React.createRef();
    public constructor(props: UserCenterProps) {
        super(props);
        this.state = {
            isLoading: false,
        };
    }

    public async componentDidMount(): Promise<void> {
        try {
            const resp = await consoleApi.user.teamData();
            this.formRef.current!.setFieldsValue({
                userName: resp.data.admin.name,
                companyName: resp.data.team.name,
                companyAddress: resp.data.team.address,
            });
        } catch (error) {
            message.error(error);
        }
    }

    private handleSubmit = async (values: any): Promise<void> => {
        const { intl } = this.props;
        try {
            await loginStore.updateInf(
                this.props.history,
                values.userName,
                values.companyName,
                values.companyAddress,
                miniPersistStore.token,
                true);
        } catch (error) {
            message.error(intl.formatMessage({ id: "global.update-inf-fail" }));
        }
    }

    private renderInfEdit = (): React.ReactNode => {
        const { intl } = this.props;
        return (
            <div className="console-content-chart-body">
                <div className="console-user-inf">
                    <Form ref={this.formRef} onFinish={this.handleSubmit} className="console-user-mid">
                        <FormItem
                            rules={[{ required: true, message: intl.formatMessage({ id: "please-admin-name" }) }]}
                            name={"userName"}
                        >
                            <Input size={"large"}
                                   placeholder={intl.formatMessage({ id: "admin-name-holder" })} />
                        </FormItem>
                        <FormItem
                            name={"companyName"}
                            rules={[{ required: true, message: intl.formatMessage({ id: "please-company-name" }) }]}
                        >
                            <Input size={"large"}
                                   className="reset-company-inf"
                                   placeholder={intl.formatMessage({ id: "company-holder" })} />
                        </FormItem>
                        <FormItem
                            name={"companyAddress"}
                            initialValue={teamStore.team ? teamStore.team.address : ""}
                            rules={[{ required: true, message: "请选择公司所在的区域" }]}
                        >
                            <Input size={"large"} placeholder={"所在的区域"}/>
                        </FormItem>
                        <FormItem>
                            <Button
                                size="large"
                                htmlType="submit"
                                style={{width: 300}}
                                type="primary">
                                {intl.formatMessage({ id: "global.update" })}
                            </Button>
                        </FormItem>
                    </Form>
                </div>
            </div>
        );
    }
    public render(): React.ReactNode {
        return this.renderInfEdit();
    }
}

export default withRouter(injectIntl(UserInf));



// WEBPACK FOOTER //
// ./src/components/portal/userCenter/UserInf.tsx